import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "@/App";
import { AuthProvider } from "@/lib/auth-context";
import "@/index.css";

// 一覧系の再取得を抑えめにする既定。個別の useQuery で上書きする。
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // 401（未ログイン）は再試行しても回復しないため、リトライは 1 回だけ。
      retry: 1,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HeroUIProvider>
      {/* lib/toast.ts の addToast がここに描画される。 */}
      <ToastProvider placement="bottom-center" toastOffset={16} />
      <QueryClientProvider client={queryClient}>
        {/* S3/CloudFront 配信（SPA フォールバックで 403/404→index.html）のため
            BrowserRouter で問題なく動く（infra/terraform/fe.tf 参照）。 */}
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HeroUIProvider>
  </StrictMode>,
);
